import { KatalWeblabClient, Weblab } from "@amzn/katal-weblab";
import { logError } from "src/shared/logError";

export type WebLabConfig = { [key: string]: Weblab };

/**
 * A class to manage web labs, including initializing the weblab treatments
 * and getting individual treatments.
 */
export class WeblabManager<T extends WebLabConfig> {

    // The list of weblabs available for use
    private readonly config: T;

    // The katal weblab client configured for the current platform
    private readonly client: KatalWeblabClient;

    constructor(
        config: T,
        client: KatalWeblabClient,
    ) {
        this.config = config;
        this.client = client;
    }

    /**
     * Get the treatment by passing in a weblab name provided in the current config
     */
    async getTreatment(weblabName: keyof T): Promise<string> {
        if (!(weblabName in this.config)) {
            throw new Error(`Weblab ${weblabName.toString()} is not provided in config`);
        }

        const entry = this.config[weblabName];

        try {
            const treatment = await this.client.getTreatment(entry);

            // try {
            //     await treatment.recordTrigger();
            // } catch (e) {
            //     logError(e, "Unable to record weblab trigger");
            // }

            if (!treatment.treatmentValue) {
                logError(`Null treatment value found for Weblab.`, `Null treatment value found for Weblab:
                 ${weblabName.toString()}. Returning default treatment: ${entry.defaultTreatment}.`);
                return entry.defaultTreatment;
            }

            return treatment.treatmentValue;
        } catch (e) {
            logError(e, `Vibes could not fetch treatment for weblab ${weblabName.toString()}`);
        }

        return entry.defaultTreatment;
    }
}